import React, { FC, ReactElement } from 'react';
import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { clsx } from 'clsx';
import SvgIcon, { SvgIconProps } from './SvgIcon';

interface RoundedIconProps extends SvgIconProps {
    customBackground?: 'lightblue' | 'grey' | 'red' | 'green';
}

const RoundedIcon: FC<RoundedIconProps> = (props): ReactElement => {
    const classes = useStyles();
    const { customBackground = 'lightblue', ...rest } = props;

    return (
        <div className={clsx(classes.roundedIconContainer, classes[customBackground])}>
            <SvgIcon {...rest} />
        </div>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        roundedIconContainer: {
            width: 40,
            height: 40,
            padding: 10,
            borderRadius: 8,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        lightblue: {
            backgroundColor: theme.palette.colors.border,
        },
        grey: {
            backgroundColor: theme.palette.colors.background.primaryElement,
        },
        red: {
            backgroundColor: theme.palette.colors.background.lightRed,
        },
        green: {
            backgroundColor: theme.palette.colors.background.lightGreen,
        },
    }),
);

export default RoundedIcon;
